<template>
    <div class="edit-drawer">
        <div class="title-container">
            <div class="title-area">
                <span>{{title}}</span>
            </div>
            <div class="btn-area">
                <slot name='btn-area'></slot>
            </div>
        </div>
        <div class="form-container">
            <slot name='content'></slot>
        </div>
        <div class="footer-container">
            <slot name='footer'></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '面板标题'
        }
    },
}
</script>

<style lang='scss'>
.edit-drawer {
    @include flex(column, space-between, flex-start);
    height: 100%;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    background-color: $white;
    position: absolute;
    z-index: 1;
    top: 0;
    .title-container, .form-container, .footer-container {
        width: 100%;
    }
    .form-container {
        @include scrollbar();
        height: calc(100% - 122px);
        box-sizing: border-box;
        padding: 20px 30px;
        overflow-y: auto;
        .form-block {
            display: flex;
            align-items: flex-start;
            .block-left {
                width: 120px;
            }
            .block-right {
                width: calc(100% - 120px);
                .ant-form {
                    .ant-form-item {
                        display: flex;
                        margin-bottom: 16px;
                        .ant-form-item-label {
                            width: 120px;
                        }
                        .ant-form-item-control-wrapper{
                            width: calc(80% - 120px);
                        }
                        .ant-form-explain {
                            position: absolute;
                        }
                    }
                }
            }
        }
    }
    .footer-container {
        padding-left: 280px;
        @include fh;
    }
}
</style>